import { TaxiAchievementApiTaxiAchievementCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiAchievementCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiAchievementApiTaxiAchievementCreateRequest, config) =>
      appApiClient.taxiAchievementApi.taxiAchievementCreate(req, config),
  });
